import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
  background-color: #fff;
  border: 1px solid #dbdfea;
  border-radius: 2px;
`;

export const Title = styled.h3`
  margin: 0 0 24px;
  color: #000;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props.$isTotal ? "0" : "12px")};
`;

export const Label = styled.span`
  color: ${(props) => (props.$isTotal ? "#000" : "#8f95a5")};
  font-size: ${(props) => (props.$isTotal ? "16px" : "14px")};
  font-weight: ${(props) => (props.$isTotal ? "700" : "500")};
  line-height: 1.5;
`;

export const Value = styled.span`
  color: ${(props) => (props.$isTotal ? "#000" : "#8f95a5")};
  font-size: ${(props) => (props.$isTotal ? "16px" : "14px")};
  font-weight: ${(props) => (props.$isTotal ? "700" : "500")};
  line-height: 1.5;
  text-align: right;
`;

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background-color: #dbdfea;
  border: none;
`;

export const ErrorMessage = styled.div`
  margin-top: 16px;
  padding: 12px;
  color: #e1000f;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  background-color: #fef2f2;
  border-radius: 2px;
`;

export const UserCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  margin: 24px 0 0;
  padding: 0 16px 0 12px;
  background-color: #f4f4f4;
  border-radius: 1px;
`;

export const UserCardAvatar = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  margin-right: 6px;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const UserCardBody = styled.div`
  display: flex;
  align-items: center;
`;

export const UserCardPoints = styled.div`
  color: #8f95a5;
  font-size: 13px;
  font-weight: 700;
  text-align: right;
  text-transform: uppercase;
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
`;

